/**
 * Default link-preview image. Crawlers read this from the first HTML response
 * and do not run the app, so the URL must be public HTTPS.
 * Square Bloom mark already used as the public SEO logo (500×500).
 */
export const WEB_SHARE_IMAGE_URL =
  'https://bloomholding.com/application/themes/bloomholding/dist/images/logo-seo.jpg';

export const WEB_SHARE_IMAGE_WIDTH = '500';
export const WEB_SHARE_IMAGE_HEIGHT = '500';
export const WEB_SHARE_IMAGE_TYPE = 'image/jpeg';
